import { useCallback } from 'react';
import { Trans } from '@lingui/macro';
import Button from '@material-ui/core/Button';
import { buildCreatePageTarget, buildPageId } from '../AdminLinkUtils';
import Link from '../../links/Link';
import {
    ID_MAPPING,
    LIST_NEED_ALERT,
    QUERY_LOADER_OPTION,
    VIRTUAL_INFRASTRUCTURE_ADMIN_LIST_DATA_EMPTY_TEXT,
    VIRTUAL_INFRASTRUCTURE_ADMIN_LIST_DATA_TABLE_ID,
    VIRTUAL_INFRASTRUCTURE_DATA_SOURCE,
    VIRTUAL_INFRASTRUCTURE_FUNCTION_NAME,
    VIRTUAL_INFRASTRUCTURE_INITIAL_SORT_FIELD_INFO,
    VIRTUAL_INFRASTRUCTURE_TITLE,
    VIRTUAL_LIST_ENABLE_DISABLE_URLS,
} from '../infrastructure/InfrastructureConstants';
import { FilterContainer } from '../../page-framework';
import { SubTypeFilter } from '../../filters/virtual-infrastructure-type-filter/SubTypeFilter';
import { VIRTUAL_INFRASTRUCTURE_COLUMNS } from '../infrastructure/InfrastructureHelper';
import { CREATE, DISABLE, ENABLE } from '../../../services/FormDataTableActionService';
import ConfirmDataTableActionButton from '../../form/ConfirmDataTableActionButton';
import InfrastructureListBase from '../infrastructure/InfrastructureListBase';
import { useVirtualInfrastructureDialogs } from '../infrastructure/hooks/UseVirtualInfrastructureDialogs';

export default function VirtualInfrastructureList() {
    const { getConfirmMsg, isNeedConfirm } = useVirtualInfrastructureDialogs();

    // Memoize action buttons function to prevent re-creation on every render
    const renderActionButtons = useCallback(
        ({
            filterState,
            isDataTableActionButton,
            dataTableActioning,
            selectionData,
            tableSelection,
            tableState,
            handleConfirmedDataTableAction,
        }) => (
            <>
                <ConfirmDataTableActionButton
                    key={DISABLE}
                    label={<Trans>Disable</Trans>}
                    disabled={isDataTableActionButton}
                    handleConfirmedDataTableAction={(event) =>
                        handleConfirmedDataTableAction(
                            event,
                            DISABLE,
                            null,
                            filterState,
                            tableSelection,
                            tableState,
                            LIST_NEED_ALERT
                        )
                    }
                    confirmMsg={() => getConfirmMsg(DISABLE, selectionData.current)}
                    plural={selectionData.current?.selectionLength > 1}
                    needConfirm={isNeedConfirm(selectionData.current)}
                />
                <ConfirmDataTableActionButton
                    key={ENABLE}
                    label={<Trans>Enable</Trans>}
                    disabled={isDataTableActionButton}
                    handleConfirmedDataTableAction={(event) =>
                        handleConfirmedDataTableAction(
                            event,
                            ENABLE,
                            null,
                            filterState,
                            tableSelection,
                            tableState,
                            LIST_NEED_ALERT
                        )
                    }
                    confirmMsg={() => getConfirmMsg(ENABLE, selectionData.current)}
                    plural={selectionData.current?.selectionLength > 1}
                    needConfirm
                />
                <Button
                    key={CREATE}
                    component={Link}
                    disabled={dataTableActioning}
                    to={buildCreatePageTarget(VIRTUAL_INFRASTRUCTURE_FUNCTION_NAME)}
                    variant="contained"
                    color="primary"
                >
                    <Trans>Create vCenter</Trans>
                </Button>
            </>
        ),
        [getConfirmMsg, isNeedConfirm]
    );

    return (
        <InfrastructureListBase
            title={VIRTUAL_INFRASTRUCTURE_TITLE}
            pageId={buildPageId(VIRTUAL_INFRASTRUCTURE_FUNCTION_NAME)}
            tableId={VIRTUAL_INFRASTRUCTURE_ADMIN_LIST_DATA_TABLE_ID}
            dataSource={VIRTUAL_INFRASTRUCTURE_DATA_SOURCE}
            columns={VIRTUAL_INFRASTRUCTURE_COLUMNS}
            sorters={VIRTUAL_INFRASTRUCTURE_INITIAL_SORT_FIELD_INFO}
            emptyText={VIRTUAL_INFRASTRUCTURE_ADMIN_LIST_DATA_EMPTY_TEXT}
            idMapping={ID_MAPPING}
            actionUrls={VIRTUAL_LIST_ENABLE_DISABLE_URLS}
            loaderOptions={QUERY_LOADER_OPTION}
            filterElement={
                <FilterContainer showFilterMenu={false}>
                    <SubTypeFilter required />
                </FilterContainer>
            }
            actionButtonsFn={renderActionButtons}
        />
    );
}
